import NiceModal from '@ebay/nice-modal-react';
import 'swiper/css';
import 'swiper/css/pagination';

import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { getOTOPackageList } from 'pages/OTOModules/OTOPackageListSlice';

import { PAYMENT } from 'services/consts';

import AppLogger from 'utils/AppLogger';

import FeatureTable from './FeatureTable';

const FeatureBreakdownModal = NiceModal.create(({ planType }) => {
	const dispatch = useDispatch();

	const axios = useAxiosPrivate();

	useEffect(() => {
		dispatch(getOTOPackageList());
	}, []);
	const user = useSelector((state) => state.user);

	const [packages, setPackages] = useState([]);
	const [currentPackage, setCurrentPackage] = useState({});
	const [featuresBreakdown, setFeaturesBreakdown] = useState([]);

	const getSubscriptionPackageDetails = useCallback(async () => {
		const response = await axios.post(PAYMENT.GET_SUBSCRIPTION_PACKAGE_DETAILS);

		if (response.status === 200) {
			setPackages(response.data.packages);
			setFeaturesBreakdown(response.data.featuresBreakdown);
			setCurrentPackage(response.data.packages.find((item) => item.planName === user.nextPackageName));
		} else {
			AppLogger.error(response);
		}
	}, [user.planName, packages]);

	useEffect(() => {
		getSubscriptionPackageDetails();
	}, []);

	return (
		<Modal fullwidth maxWidth="x-large" className="feature-breakdown-modal" closeButton={true}>
			<ModalTitle>
				<Typography variant="p1">upgradeAccount.featuresBreakdownHeader</Typography>
			</ModalTitle>
			<ModalContent>
				<FeatureTable
					packages={packages}
					currentPackage={currentPackage}
					planType={planType}
					featuresBreakdown={featuresBreakdown}
				/>
			</ModalContent>
		</Modal>
	);
});

export default FeatureBreakdownModal;
